import {
  AppstoreOutlined,
  BankOutlined,
  BlockOutlined,
  CarOutlined,
  ClockCircleOutlined,
  GiftOutlined,
  ShopOutlined,
  ShoppingCartOutlined,
  TagsOutlined,
  TeamOutlined,
} from "@ant-design/icons";

// Keyed by the name Dashboard.js renders, because the same tiles are repeated
// per role branch and would otherwise drift apart.
export const TILES = {
  "Today Orders": { to: "/orders", Icon: ClockCircleOutlined },
  "Total Orders": { to: "/orders", Icon: ShoppingCartOutlined },
  "Total Products": { to: "/products", Icon: AppstoreOutlined },
  "Total Offer Count": { to: "/offer-products", Icon: TagsOutlined },
  "Total Active Restaurants": { to: "/restaurants", Icon: ShopOutlined },
  "Total Coupons": { to: "/promocode", Icon: GiftOutlined },
  "Total Sections": { to: "/sections", Icon: BlockOutlined },
  "Total Customers": { to: "/customers", Icon: TeamOutlined },
  "Total Delivery Boys": { to: "/delivery-boys", Icon: CarOutlined },
  "Total Franchise": { to: "/franchises", Icon: BankOutlined },
};
